import { createContext, useContext, useState, ReactNode } from 'react';

interface HeaderContextType {
  customHeader: ReactNode | null;
  setCustomHeader: (header: ReactNode | null) => void;
  useCustomHeader: boolean;
  setUseCustomHeader: (use: boolean) => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const HeaderProvider = ({ children }: { children: ReactNode }) => {
  const [customHeader, setCustomHeader] = useState<ReactNode | null>(null);
  const [useCustomHeader, setUseCustomHeader] = useState(false);

  return (
    <HeaderContext.Provider value={{ 
      customHeader, 
      setCustomHeader, 
      useCustomHeader, 
      setUseCustomHeader 
    }}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeader must be used within HeaderProvider');
  }
  return context;
};
